const getFromHost = async () => {
	const host = window.location.hostname;
	const options = {
		method: 'GET',
	};

	const url =
		host.indexOf('localhost') > -1
			? 'http://localhost:3000/config/settings.json'
			: `https://${host}/config/settings.json`;
	const response = await fetch(url, options);
	if (response.ok) {
		const result = await response.json();
		Object.keys(result).forEach((settingName) =>
			localStorage.setItem(settingName, result[settingName])
		);
		return result;
	}

	throw response.statusText || 'Api error';
};

export default {
	getFromHost,
};
